import api from './api';

const usersService = {
  // Get user profile
  getProfile: () => api.get('/users/profile'),

  // Update user profile
  updateProfile: (data) => api.put('/users/profile', data),

  // Get user settings
  getSettings: () => api.get('/users/settings'),

  // Update user settings
  updateSettings: (data) => api.put('/users/settings', data)
};

export default usersService;
